<template>
  <div :class="['list-item', playedGame.winner ? 'win' : 'loose']">
    <div class="list-item__avatar">
      <div class="avatar_status"><img :src="playedGame.avatar" alt="" @click.prevent="showUserProfile()" style="cursor: pointer;">
        <div
          :class="[playedGame.bot || isUserOnlineMethod(playedGame.opponentName) ? 'bubble_online' : 'bubble_ofline']">
          <span class="bubble-outer-dot">
            <span class="bubble-inner-dot"></span>
          </span>
        </div>
      </div>
      <div class="list-item__info"><span class="list-item__info__name">{{ playedGame.opponentName }}</span>
        <div v-if="playedGame.home" class="list-item__score" @click="matchInfo()"
             style="cursor:pointer">{{ playedGame.playerScore }}-{{ playedGame.opponentScore }}
        </div>
        <div v-if="!playedGame.home" class="list-item__score" @click="matchInfo()"
             style="cursor:pointer">{{ playedGame.opponentScore }}-{{ playedGame.playerScore }}
        </div>
      </div>
    </div>
    <div class="list_actions">
      <div class="action_container" v-show="loaded">
        <chat-bubble v-if="getMessagingConfig.messagingEnabled"
                     :username="playedGame.opponentName"
                     :class="['chat_action', { deactivated: playedGame.bot }]"/>
        <star :action-on-click="() => markFavorite(playedGame.opponentName)"
              :is-checked="isFavorite"
              :key-id="_uid"/>
        <versus :is-modal="false"
                :action-on-click="() => playGameMethod(playedGame.bot, playedGame.opponentName, playedGame.avatar, playedGame.level)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import UserList from '@/components/home/shared/GenericList';
import FavoriteUser from '@/components/home/users/FavoriteUser';
import { ChecksToStartNewGame } from '@/common/mixins/rematch/rematch';
import Star from '@/components/home/shared/Star';
import virtualList from 'vue-virtual-scroll-list';
import ScoreDescription from '../modals/ScoreDescription';
import ChatBubble from '../shared/ChatBubble';
import Versus from '../shared/Versus';

export default {
  name: 'history-data-user',
  props: {
    playedGame: Object,
  },
  components: {
    Versus,
    ChatBubble,
    ScoreDescription,
    Star,
    UserList,
    FavoriteUser,
    VirtualList: virtualList,
  },
  mixins: [ChecksToStartNewGame],
  data() {
    return {
      username: '',
      loaded: false,
    };
  },
  created() {
    if (!this.getExtraUsers.filter(user => user.username === this.playedGame.opponentName).length) { // if not in searchedUsers, search for it
      this.searchSpecificUser({ username: this.playedGame.opponentName }).then(() => {
        this.loaded = true;
      });
    } else this.loaded = true;
  },
  methods: {
    ...mapActions('profile', [
      'setMatchInfo',
    ]),
    ...mapMutations('users', [
      'clearSearchedUsers',
      'setSelectedUser',
    ]),
    ...mapActions('users', [
      'searchSpecificUser',
      'markFavoriteUser',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
      'toggleNeedLoad',
    ]),
    showUserProfile() {
      if (this.getExtraUsers.filter(user => user.username === this.playedGame.opponentName).length) {
        this.setSelectedUser(this.playedGame.opponentName);
        this.$router.push({ name: 'other-user-profile' });
      }
    },
    matchInfo() {
      this.setMatchInfo(this.playedGame).then(() => {
        this.storeModalForHomePage(ScoreDescription);
      });
    },
    isUserOnlineMethod(opponentUsername) {
      return this.onlineUsers.some(users => users.username === opponentUsername);
    },
    markFavorite(user) {
      this.markFavoriteUser(user);
    },
    playGameMethod(isBot, name, avatar, level) {
      this.checkGameValidations(false, name, avatar, isBot ? null : level);
    },
  },
  computed: {
    ...mapGetters('users', [
      'getExtraUsers',
    ]),
    ...mapGetters('users', [
      'hasErrorResult',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('users', [
      'favoriteUsers',
      'onlineUsers',
    ]),
    ...mapGetters('common', [
      'getMessagingConfig',
    ]),
    isFavorite() {
      return !!this.favoriteUsers[this.playedGame.opponentName];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/HistoryDataUser.vue